import { useMemo } from 'react';
type InventoryFieldType = 'simple' | 'advanced';

/**
 * Hook to get inventory fields from the form
 *
 * @param type Optional inventory type to filter by
 * @return Array of fields with inventory enabled
 */
export function useInventoryFields(
	type?: InventoryFieldType
): GravityFormsField[] {
	return useMemo(() => {
		return window.form.fields.filter((field) => {
			if (type) {
				return field.gpiInventory === type;
			}

			return Boolean(field.gpiInventory);
		});
	}, [type]);
}
